import { ResponseCreateProduct, RequestCreateProduct } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { CreateProductActions } from '../actions';
import { CreateProductTypes } from '../../shared/enums';

export interface CreateProductState {
    response: ResponseCreateProduct;
    request: RequestCreateProduct;
    error: any;
}

export const CreateProductInitialState: CreateProductState = {
    response: null,
    request: null,
    error: null
};

const _createProductReducer = createReducer(
    CreateProductInitialState,

    on(CreateProductActions.getCreateProduct, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(CreateProductActions.getCreateProductSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(CreateProductActions.getCreateProductError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(CreateProductActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function createProductReducer(state, action) {
    if (action.type === CreateProductTypes.CREATEPRODUCT) {
        state = undefined;
    }
    return _createProductReducer(state, action);
}
